<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="学生名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入学生名称" />
        </a-form-model-item>
        <a-form-model-item label="班级" prop="gradeClassId">
          <a-select v-model="form.gradeClassId" placeholder="请选择班级">
            <a-select-option
              :value="item.id"
              v-for="(item, index) in gradeList"
              :key="index"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="性别" prop="sex">
          <a-radio-group
            v-model="form.sex"
            button-style="solid"
            placeholder="请选择教师性别"
          >
            <a-radio-button
              :value="item.value"
              v-for="(item, index) in sexList"
              :key="index"
            >
              {{ item.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="form.status" button-style="solid">
            <a-radio-button
              :value="item.value"
              v-for="(item, index) in statusList"
              :key="index"
            >
              {{ item.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="人脸照片" prop="faceFileList">
          <a-input
            v-model="form.faceFileList"
            placeholder="请上传人脸照片"
            hidden
          />
          <UploadFile
            :defaultFile="form.faceFileList"
            type="img"
            businessType="PERSONNEL_CONTRACT"
            @uploadOk="uploadOk"
            maxCount="3"
          />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { Student, Classlist } from "@/api";
import { mapState } from "vuex";
import UploadFile from "@/components/PubUpload/UploadFile";
export default {
  components: { UploadFile },
  computed: {
    ...mapState("user", ["schoolId"]),
  },
  data() {
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        name: "",
        classSort: "99",
        status: "1",
        schoolId: "",
      },
      form: {},
      statusList: [],
      gradeList: [],
      sexList: [
        { value: "1", label: "女" },
        { value: "2", label: "男" },
      ],
      rules: {
        name: [
          {
            required: true,
            message: "请输入教师名称!",
            trigger: "change",
          },
        ],
        gradeClassId: [
          {
            required: true,
            message: "请选择年级班级!",
            trigger: "change",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别!",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态!",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    async open(type, data) {
      this.type = type;
      this.title = type == "edit" ? "编辑学生" : "添加学生";
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(this.formData));
      if (type == "edit" && data) {
        this.form = JSON.parse(JSON.stringify(data));
        this.form.status = data.status + "";
        this.form.sex = data.sex + "";
        delete this.form.createTime;
        delete this.form.updateTime;
      }
      // 获取数据字典
      this.statusList = await this.common.getSysCodeType("SYS_STATUS");
      this.getClass();
      console.log(this.statusList);
    },
    getClass() {
      Classlist.gradeClassPage({
        schoolId: this.schoolId,
        paging: {
          page: 1,
          limit: 20,
        },
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.gradeList = res.data;
        }
        this.loading = false;
      });
    },

    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          newForm.schoolId = this.schoolId;
          if (this.type == "add") {
            delete newForm.id;
          }
          this.submitSave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传合同结束
    uploadOk(data) {
      this.form.faceFileList = data;
      this.$forceUpdate();
    },

    // 提交
    submitSave(data) {
      this.confirmLoading = true;
      Student.studentBasicSave(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "edit" ? "修改成功！" : "添加成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
